import React from 'react';
import { Link } from 'react-router-dom';
import StatusPage from './StatusPage.jsx';

export const UnauthorizedPage = () => (
  <StatusPage
    code="401"
    icon="fas fa-lock"
    title="Sign in required"
    message="You need to sign in to view this page."
    action={<Link className="btn btn-primary" to="/login">Log in</Link>}
  />
);

export const ForbiddenPage = () => (
  <StatusPage
    code="403"
    icon="fas fa-ban"
    title="Access denied"
    message="Your account does not have permission to open this page."
  />
);

export const NotFoundPage = () => (
  <StatusPage
    code="404"
    icon="fas fa-map-signs"
    title="Page not found"
    message="The page you are looking for does not exist or has not been built yet."
  />
);

export const ServerErrorPage = () => (
  <StatusPage
    code="500"
    icon="fas fa-exclamation-triangle"
    title="Something went wrong"
    message="An unexpected error occurred. Please try again in a moment."
  />
);
